import useStyles from "./styles";
import { FC, ReactNode } from "react";
import { Checkbox } from "@mui/material";

type Props = {
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: () => void;
  label?: string | ReactNode; // Updated to accept both string and ReactNode
};

export const CustomCheckBoxService: FC<Props> = ({
  checked,
  onChange,
  indeterminate,
  label,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.checkboxContainer}>
      <Checkbox
        className={classes.checkbox}
        size={"small"}
        indeterminate={indeterminate}
        checked={checked}
        onChange={onChange}
      />
      {label && (
        <div className={classes.label}>
          {typeof label === 'string' ? <span>{label}</span> : label}
        </div>
      )}
    </div>
  );
};